// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* le tooltip FloatingVue est teleporté hors du composant, donc pas de scoped ici */
.ak-context-menu-tooltip .v-popper__inner {
  max-width: 260px;
  white-space: pre-line;
  word-break: break-word;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
